import React from 'react';
import PropTypes from 'prop-types';

const SignedBarChartLabel = ({ x, y }) => (
  <g>
    <text x={x + 30} y={y + 20}>
      Male
    </text>
    <text x={x + 105} y={y + 20}>
      Female
    </text>
  </g>
);

SignedBarChartLabel.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
};

export default SignedBarChartLabel;



// WEBPACK FOOTER //
// ./src/components/Areas/AreaOverview/SignedBarChart/SignedBarChartAxisLabel.js